import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTransportationHeaderInfo } from "../../../actions";
import { selectProcedure } from "../../../selectors";
import { useUpdateEffect } from "../../../../hooks";
import ItineraryForm from "./itineraryForm";

const Itinerary=({isImportShipment,isDMS,saveForm})=>{
  const dispatch=useDispatch()
  const procedure = useSelector(selectProcedure);
  const dataSource = useSelector((state) => state.Shipment.transportation);
  const saveData=useCallback((params)=>saveForm({transportation:params}),[saveForm])
  const onUpdate=useCallback((params)=>dispatch(updateTransportationHeaderInfo(params)),[])
  
  const {displayInfo,disableForm}=useMemo(()=>{
    if(!isDMS) return {}
    const list=  isImportShipment ? { tranNatureProc:["H2","H6","I2"],paymentProc:[] }:{tranNatureProc:["B3","C2"],paymentProc:["B3","B4"]}
    return {disableForm:{disableTranNature:list.tranNatureProc.includes(procedure)?{isDisabled:true} :{},disabledPaymentInfo:list.paymentProc.includes(procedure)?{isDisabled:true} :{}},displayInfo:{tranNatureInfo:list.tranNatureProc?.toString(),paymentInfo:list.paymentProc?.toString()}}
  },[procedure,isImportShipment,isDMS]
  )

  useUpdateEffect(()=>{
     if(disableForm?.disableTranNature?.isDisabled){
      saveData({transactionNature:" "})
      onUpdate({"transactionNature":""})
     }
  },[disableForm?.disableTranNature?.isDisabled])

  useUpdateEffect(()=>{
    if(disableForm?.disabledPaymentInfo?.isDisabled){
     saveData({paymentMethod:" "})
     onUpdate({"paymentMethod":""})
    }
 },[disableForm?.disabledPaymentInfo?.isDisabled])

 
 return (
    <ItineraryForm
    dataSource={dataSource}
    onUpdate={onUpdate}
    saveData={saveData}
    isDMS={isDMS}
    isImportShipment={isImportShipment}
    displayInfo={displayInfo}
    disableForm={disableForm}
     />
  );
}

export default React.memo(Itinerary)
